export default {
  "content": "<path fill=\"#fff\" fill-rule=\"evenodd\" d=\"M24 48c13.255 0 24-10.745 24-24S37.255 0 24 0 0 10.745 0 24s10.745 24 24 24z\" clip-rule=\"evenodd\"/><path fill=\"#00809D\" fill-rule=\"evenodd\" d=\"M24 37a1 1 0 01-1-1V12a1 1 0 012 0v24a1 1 0 01-1 1\" clip-rule=\"evenodd\"/><path fill=\"#00809D\" fill-rule=\"evenodd\" d=\"M24 37.415l-9.707-9.707a1 1 0 011.414-1.414L24 34.587l8.293-8.293a.999.999 0 111.414 1.414L24 37.415z\" clip-rule=\"evenodd\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "48",
    "height": "48",
    "fill": "none",
    "viewBox": "0 0 48 48"
  }
};